import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/disclaimer/WhatsApp_logo.png'
import _imports_1 from '../assets/disclaimer/mobile_device.png'
import _imports_2 from '../assets/disclaimer/check.png'
import _imports_3 from '../assets/disclaimer/start.png'
import _imports_4 from '../assets/disclaimer/shoes.png'
import _imports_5 from '../assets/disclaimer/Digital_Glyph_Green.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  style: {"background-color":"#b2b2b2","max-height":"100px !important"}
}
const _hoisted_3 = { class: "row items-center full-width" }
const _hoisted_4 = { class: "col-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-7" }
const _hoisted_7 = {
  class: "text-weight-bolder text-white q-pa-xs",
  style: {"font-size":"1.3em","padding-left":"5px","color":"#514d4d"}
}
const _hoisted_8 = {
  key: 1,
  style: {"background-color":"#b2b2b2","max-height":"45px !important"}
}
const _hoisted_9 = { class: "row justify-evenly items-center full-width" }
const _hoisted_10 = {
  class: "text-weight-bolder q-pa-xs",
  style: {"font-size":"0.9em"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"max-width":"150px","filter":"brightness(0) invert(1)"}
  })
], -1)
const _hoisted_12 = { class: "col-8 row full-width justify-center items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"max-height":"220px"},
  draggable: "false"
}, null, -1)
const _hoisted_14 = { class: "q-mt-md text-center" }
const _hoisted_15 = { class: "row justify-center q-pb-md" }
const _hoisted_16 = {
  class: "column justify-evenly",
  style: {"height":"90%","max-height":"50vh"}
}
const _hoisted_17 = {
  class: "text-center text-black col-auto",
  style: {"font-size":"0.95rem"}
}
const _hoisted_18 = {
  key: 0,
  class: "text-bold"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify-center items-center q-pt-sm" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      draggable: "false",
      style: {"max-height":"40px"}
    })
  ])
], -1)
const _hoisted_20 = { class: "row justify-center q-pb-md" }
const _hoisted_21 = {
  class: "column justify-evenly",
  style: {"height":"90%","max-height":"50vh"}
}
const _hoisted_22 = { class: "text-center text-black col-auto" }
const _hoisted_23 = { class: "text-bold" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col col-6 q-pt-sm" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    draggable: "false",
    style: {"max-width":"100%"}
  })
], -1)
const _hoisted_25 = { class: "row justify-center q-pb-md" }
const _hoisted_26 = {
  class: "column justify-evenly",
  style: {"height":"90%","max-height":"50vh"}
}
const _hoisted_27 = { class: "text-center text-black col-auto" }
const _hoisted_28 = { class: "text-bold" }
const _hoisted_29 = { class: "col col-8 q-pt-sm" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "row justify-center q-pb-md" }
const _hoisted_32 = { class: "row full-width justify-center items-center q-pb-md" }
const _hoisted_33 = {
  class: "column justify-evenly",
  style: {"height":"90%","max-height":"50vh"}
}
const _hoisted_34 = { class: "text-center text-black col-auto" }
const _hoisted_35 = { class: "text-bold" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col col-10 q-pt-sm" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    draggable: "false",
    style: {"height":"100%","max-height":"20vh"}
  })
], -1)
const _hoisted_37 = { class: "q-pt-sm" }
const _hoisted_38 = {
  key: 0,
  class: "row justify-center items-center full-width q-pa-sm"
}
const _hoisted_39 = { class: "col-auto" }
const _hoisted_40 = { class: "column" }
const _hoisted_41 = ["href"]
const _hoisted_42 = ["href"]
const _hoisted_43 = ["href"]
const _hoisted_44 = ["href"]
const _hoisted_45 = ["href"]
const _hoisted_46 = ["href"]
const _hoisted_47 = ["href"]
const _hoisted_48 = ["href"]
const _hoisted_49 = ["href"]
const _hoisted_50 = ["href"]
const _hoisted_51 = ["href"]
const _hoisted_52 = ["href"]
const _hoisted_53 = ["href"]
const _hoisted_54 = ["href"]
const _hoisted_55 = ["href"]
const _hoisted_56 = ["href"]
const _hoisted_57 = ["href"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-top":"3px"} }, null, -1)
const _hoisted_59 = ["href"]
const _hoisted_60 = ["href"]
const _hoisted_61 = {
  key: 1,
  class: "q-pt-sm"
}
const _hoisted_62 = {
  key: 0,
  src: _imports_5,
  style: {"max-width":"30px","margin-right":"10px","height":"auto","filter":"brightness(0) invert(1)"},
  alt: "WhatsApp"
}
const _hoisted_63 = {
  class: "text-elipsis",
  style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "disclaimer-bg-image" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-center q-pa-md" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"height":"80px","filter":"brightness(0) invert(1)"}
  })
], -1)
const _hoisted_68 = {
  key: 0,
  class: "row justify-center"
}
const _hoisted_69 = {
  key: 1,
  class: "row justify-center"
}
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { class: "row justify-begin" }
const _hoisted_72 = { class: "text-white q-pa-lg" }
const _hoisted_73 = {
  key: 0,
  class: "text-bold"
}
const _hoisted_74 = { class: "row full-width q-pb-xl q-pl-sm q-pr-sm" }
const _hoisted_75 = { class: "text-white col-10" }
const _hoisted_76 = ["href"]
const _hoisted_77 = ["href"]
const _hoisted_78 = ["href"]
const _hoisted_79 = ["href"]
const _hoisted_80 = ["href"]
const _hoisted_81 = ["href"]
const _hoisted_82 = ["href"]
const _hoisted_83 = ["href"]
const _hoisted_84 = ["href"]
const _hoisted_85 = ["href"]
const _hoisted_86 = ["href"]
const _hoisted_87 = ["href"]
const _hoisted_88 = ["href"]
const _hoisted_89 = ["href"]
const _hoisted_90 = ["href"]
const _hoisted_91 = ["href"]
const _hoisted_92 = ["href"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-top":"3px"} }, null, -1)
const _hoisted_94 = ["href"]
const _hoisted_95 = ["href"]
const _hoisted_96 = {
  key: 0,
  class: "row full-width q-pb-xl q-pl-sm q-pr-sm"
}
const _hoisted_97 = { class: "text-white col-10" }
const _hoisted_98 = ["href"]
const _hoisted_99 = ["href"]
const _hoisted_100 = ["href"]
const _hoisted_101 = {
  key: 1,
  class: "text-white q-pl-sm q-pr-sm",
  style: {"font-size":"0.55rem !important"}
}
const _hoisted_102 = ["href"]
const _hoisted_103 = ["href"]
const _hoisted_104 = ["href"]
const _hoisted_105 = ["href"]
const _hoisted_106 = ["href"]
const _hoisted_107 = ["href"]
const _hoisted_108 = ["href"]
const _hoisted_109 = ["href"]
const _hoisted_110 = { key: 1 }
const _hoisted_111 = { class: "row justify-begin" }
const _hoisted_112 = { class: "text-h4 text-white q-pa-lg" }
const _hoisted_113 = { class: "text-bold" }
const _hoisted_114 = { class: "row full-width q-pb-xl q-pl-sm q-pr-sm" }
const _hoisted_115 = { class: "text-white col-10" }
const _hoisted_116 = ["href"]
const _hoisted_117 = ["href"]
const _hoisted_118 = ["href"]
const _hoisted_119 = ["href"]
const _hoisted_120 = ["href"]
const _hoisted_121 = ["href"]
const _hoisted_122 = ["href"]
const _hoisted_123 = ["href"]
const _hoisted_124 = ["href"]
const _hoisted_125 = ["href"]
const _hoisted_126 = ["href"]
const _hoisted_127 = ["href"]
const _hoisted_128 = ["href"]
const _hoisted_129 = ["href"]
const _hoisted_130 = ["href"]
const _hoisted_131 = ["href"]
const _hoisted_132 = ["href"]
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-top":"3px"} }, null, -1)
const _hoisted_134 = ["href"]
const _hoisted_135 = ["href"]
const _hoisted_136 = { key: 1 }
const _hoisted_137 = {
  key: 0,
  style: {"background-color":"#b2b2b2","max-height":"100px !important"}
}
const _hoisted_138 = {
  key: 0,
  class: "row items-center full-width"
}
const _hoisted_139 = { class: "col-5" }
const _hoisted_140 = ["src"]
const _hoisted_141 = { class: "col-7" }
const _hoisted_142 = {
  class: "text-weight-bolder text-white q-pa-xs",
  style: {"font-size":"1.4em","padding-left":"5px","color":"#514d4d"}
}
const _hoisted_143 = {
  key: 1,
  style: {"background-color":"#b2b2b2","max-height":"45px !important","max-width":"50vh","width":"100%"}
}
const _hoisted_144 = { class: "row justify-evenly items-center full-width" }
const _hoisted_145 = {
  class: "text-weight-bolder q-pa-xs",
  style: {"font-size":"1.1em"}
}
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"max-width":"150px","filter":"brightness(0) invert(1)"}
  })
], -1)
const _hoisted_147 = { class: "row full-width justify-evenly items-center" }
const _hoisted_148 = {
  key: 0,
  class: "row justify-evenly full-width"
}
const _hoisted_149 = {
  class: "text-white shadow-2 custom-area bg-whatsapp q-pa-md",
  style: {"height":"40vh","width":"15vw"}
}
const _hoisted_150 = { class: "column no-wrap flex-center" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"max-height":"220px"},
  draggable: "false"
}, null, -1)
const _hoisted_152 = {
  class: "q-mt-md text-center",
  style: {"font-size":"1.05rem"}
}
const _hoisted_153 = {
  class: "text-white shadow-2 custom-area bg-whatsapp",
  style: {"height":"40vh","width":"15vw","background-color":"rgb(238, 232, 223)"}
}
const _hoisted_154 = { class: "row justify-center q-pb-md" }
const _hoisted_155 = {
  class: "column justify-evenly",
  style: {"height":"90%","max-height":"50vh"}
}
const _hoisted_156 = {
  class: "text-center text-black col-auto",
  style: {"font-size":"0.95rem"}
}
const _hoisted_157 = {
  key: 0,
  class: "text-bold"
}
const _hoisted_158 = /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify-center items-center q-pt-sm" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      draggable: "false",
      style: {"max-height":"40px"}
    })
  ])
], -1)
const _hoisted_159 = {
  class: "text-white shadow-2 custom-area bg-whatsapp",
  style: {"height":"40vh","width":"15vw","background-color":"rgb(238, 232, 223)"}
}
const _hoisted_160 = { class: "row justify-center q-pb-md" }
const _hoisted_161 = {
  class: "column justify-evenly",
  style: {"height":"90%","max-height":"50vh"}
}
const _hoisted_162 = { class: "text-center text-black col-auto" }
const _hoisted_163 = { class: "text-bold" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", { class: "col col-6 q-pt-sm" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    draggable: "false",
    style: {"max-width":"100%"}
  })
], -1)
const _hoisted_165 = {
  class: "text-white shadow-2 custom-area bg-whatsapp",
  style: {"height":"40vh","width":"15vw","background-color":"rgb(238, 232, 223)"}
}
const _hoisted_166 = { class: "row justify-center q-pb-md" }
const _hoisted_167 = {
  class: "column justify-evenly",
  style: {"height":"90%","max-height":"50vh"}
}
const _hoisted_168 = { class: "text-center text-black col-auto" }
const _hoisted_169 = { class: "text-bold" }
const _hoisted_170 = { class: "col col-8 q-pt-sm" }
const _hoisted_171 = ["src"]
const _hoisted_172 = {
  class: "text-white shadow-2 custom-area bg-whatsapp",
  style: {"height":"40vh","width":"15vw","background-color":"rgb(238, 232, 223)"}
}
const _hoisted_173 = { class: "row full-width justify-center items-center q-pb-md" }
const _hoisted_174 = {
  class: "column justify-evenly",
  style: {"height":"90%","max-height":"50vh"}
}
const _hoisted_175 = { class: "text-center text-black col-auto" }
const _hoisted_176 = { class: "text-bold" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("div", { class: "col col-10 q-pt-sm" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    draggable: "false",
    style: {"height":"100%","max-height":"18vh"}
  })
], -1)
const _hoisted_178 = { key: 1 }
const _hoisted_179 = {
  class: "row justify-center text-white shadow-2 custom-area bg-whatsapp",
  style: {"height":"47vh","width":"16vw","background-color":"rgb(238, 232, 223)"}
}
const _hoisted_180 = {
  class: "column justify-evenly",
  style: {"background-color":"rgb(238, 232, 223)"}
}
const _hoisted_181 = {
  key: 0,
  class: "row justify-center"
}
const _hoisted_182 = {
  key: 1,
  class: "row justify-center"
}
const _hoisted_183 = {
  key: 2,
  style: {"text-align":"center"}
}
const _hoisted_184 = { class: "scan-text" }
const _hoisted_185 = ["href"]
const _hoisted_186 = {
  key: 0,
  style: {"max-width":"95vw","width":"100%"}
}
const _hoisted_187 = { class: "row justify-center items-center full-width q-pa-xs" }
const _hoisted_188 = { class: "col-auto" }
const _hoisted_189 = { class: "column justify-center" }
const _hoisted_190 = ["href"]
const _hoisted_191 = ["href"]
const _hoisted_192 = ["href"]
const _hoisted_193 = ["href"]
const _hoisted_194 = ["href"]
const _hoisted_195 = ["href"]
const _hoisted_196 = ["href"]
const _hoisted_197 = ["href"]
const _hoisted_198 = ["href"]
const _hoisted_199 = ["href"]
const _hoisted_200 = ["href"]
const _hoisted_201 = ["href"]
const _hoisted_202 = ["href"]
const _hoisted_203 = ["href"]
const _hoisted_204 = ["href"]
const _hoisted_205 = ["href"]
const _hoisted_206 = ["href"]
const _hoisted_207 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-top":"3px"} }, null, -1)
const _hoisted_208 = ["href"]
const _hoisted_209 = ["href"]
const _hoisted_210 = {
  key: 0,
  class: "row justify-center items-center full-width q-pl-xs q-pr-xs"
}
const _hoisted_211 = { class: "col-auto" }
const _hoisted_212 = { class: "column justify-center" }
const _hoisted_213 = ["href"]
const _hoisted_214 = ["href"]
const _hoisted_215 = ["href"]
const _hoisted_216 = { key: 1 }
const _hoisted_217 = {
  key: 0,
  src: _imports_5,
  style: {"max-width":"30px","margin-right":"18px","filter":"brightness(0) invert(1)"},
  alt: "WhatsApp"
}

import { showErrorMsgToast } from '@/common';
import {
  DisclaimerTargetResponse,
  ILabelValue,
  ShortUrlRequest
} from '@/store/models';
import privacyConfirmModule from '@/store/modules/privacyConfirmModule';
import shortUrlModule from '@/store/modules/shortUrlModule';
import tenantModule from '@/store/modules/tenantModule';
import Cookies from 'js-cookie';
import Platform from 'quasar/src/plugins/platform/Platform.js';;
import { nextTick, onMounted } from 'vue';

import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisclaimerDesign',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const $q = useQuasar();
const { t, te, locale } = useI18n();

const name = ref('WhatsappPage');
const acceptWhatsappDataPrivacy = ref(false);
const acceptTalentPool = ref(false);
const showQrCode = ref(false);
const qrCodeLink = ref('');
const selectedLanguage = ref<ILabelValue | null>(null);
const tenantDataPrivacyUrl = ref<string | null>(null);
const tenantName = ref<string | null>(null);
const tenantIdentifier = ref<string | null>(null);
const language = ref(navigator.language);
const tenantInfoLoaded = ref(false);
const defaultLanguageCode = ref('de');
const dataPrivacyUrl = ref<string | null>(null);
const additionalTermsUrl = ref(t('message.additionalTermsUrl') as string);
const disclaimerTarget = ref<DisclaimerTargetResponse | null>(null);
const showDisclaimerText = ref(false);
const showSubmitBtn = ref(false);
const disclaimerGuid = ref<string | undefined>(undefined);
const currentIndex = ref('1');
const showDisclaimerOverlay = ref(false);
const showWhatsAppWaiting = ref(false);
const showWhatsAppSpinner = ref(false);
const showQrCodePanel = ref(false);
const customDisclaimer = ref(true);
const contactDisclaimer = ref(false);
const talentPoolDisclaimer = ref(false);
const hideDisclaimerCheckbox = ref(false);
const showOpenWhatsAppBtn = ref(false);
const redirectUrl = ref('');
const firstRedirect = ref(true);
const alternateUrl = ref('');
const useDirectUrl = ref(true);
const useWindowOpen = ref(true);
const tenantLogoUrl = ref<string | null>(null);
let logoPath = ref('/api/media/v1/logo/');
const tenantLogoGuid = ref<string | null>(null);

function additonalText1() {
  if (te('message.designDisclaimerAdditionalText1_' + tenantIdentifier.value)) {
    return t(
      'message.designDisclaimerAdditionalText1_' + tenantIdentifier.value
    );
  }

  return t('message.designDisclaimerAdditionalText1');
}

function additionalText2() {
  if (t('message.designDisclaimerAdditionalText1_' + tenantIdentifier.value)) {
    return null;
  }

  return t('message.designDisclaimerAdditionalText2');
}

function additionalText3() {
  if (te('message.designDisclaimerAdditionalText3_' + tenantIdentifier.value)) {
    return 'message.designDisclaimerAdditionalText3_' + tenantIdentifier.value;
  }

  return null;
}

function iconStyleClass() {
  return $q.platform.is.mobile
    ? 'full-width column justify-center items-center '
    : 'full-width row items-center ';
}

function isRenderTenantDataPrivacy(): boolean {
  if (
    tenantModule &&
    tenantModule.tenantInfoLite &&
    tenantModule.tenantInfoLite.dataPrivacyUrl
  ) {
    return true;
  }
  return false;
}

function swipableAreaStyle() {
  if (currentIndex.value == '1') {
    return undefined;
  }

  return 'background-color: rgb(238,232,223)';
}

function dataPrivacyText() {
  if (tenantModule.tenantInfoLite) {
    if (tenantModule.tenantInfoLite.ps) {
      return 'message.combinedDisclaimerText_prescreen';
    }

    if (tenantModule.tenantInfoLite.customDisclaimer) {
      const translationKey =
        'message.combinedDisclaimerText_' +
        tenantModule.tenantInfoLite.identifier.split('-').join('_');
      if (te(translationKey)) {
        return translationKey;
      }
    }
  }

  return 'message.combinedDisclaimerText';
}

function startButtonText() {
  if (contactDisclaimer.value) {
    return t('message.designDisclaimerStartContactButtonText');
  }

  return t('message.designDisclaimerStartButtonText');
}

function step1Text() {
  if (contactDisclaimer.value) {
    return t('message.designDisclaimerStep1ContactText');
  }

  return t('message.designDisclaimerStep1Text');
}

function whatsAppPrivacyText() {
  if (
    tenantModule.tenantInfoLite &&
    tenantModule.tenantInfoLite.customDisclaimer
  ) {
    return (
      'message.whatsappDataPrivacyTxt_' +
      tenantModule.tenantInfoLite.identifier.split('-').join('_')
    );
  }

  return 'message.whatsappDataPrivacyTxt';
}

function acceptDataPrivacyText() {
  if (
    tenantModule.tenantInfoLite &&
    tenantModule.tenantInfoLite.customDisclaimer
  ) {
    return t(
      'message.acceptWhatsappDataPrivacyTxt_' +
        +tenantModule.tenantInfoLite.identifier.replace('-', '_')
    );
  }

  return t('message.acceptWhatsappDataPrivacyTxt');
}

function dataPrivacyLink() {
  if (dataPrivacyUrl.value) {
    return dataPrivacyUrl.value;
  } else if (tenantModule.tenantInfoLite) {
    return tenantModule.tenantInfoLite.dataPrivacyUrl;
  } else {
    return t('message.defaultDataPrivacyLink');
  }
}

function termsOfUseLink() {
  if (
    tenantModule.tenantInfoLite &&
    tenantModule.tenantInfoLite.overridePitchYouLinks
  ) {
    return tenantModule.tenantInfoLite.termsOfUseUrl;
  }
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.termsOfUserDisclaimerUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.termsOfUserDisclaimerUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.termsOfUserDisclaimerUrl');
}

function additionalTermsLink() {
  if (
    tenantModule.tenantInfoLite &&
    tenantModule.tenantInfoLite.additionalTermsUrl
  ) {
    return tenantModule.tenantInfoLite.additionalTermsUrl;
  }

  return t('message.additionalTermsUrl');
}

function chatImageSrc(): string {
  try {
    const languageCode = currentLanguage();
    if (languageCode) {
      return require('../assets/disclaimer/Disclaimer_Chat_' +
        languageCode.toUpperCase() +
        '.png');
    }
  } catch (error) {
    return require('../assets/disclaimer/Disclaimer_Chat_EN.png');
  }

  return require('../assets/disclaimer/Disclaimer_Chat_EN.png');
}

onMounted(async () => {
  locale.value = currentLanguage() as string;
  onInitialPageLoad();
});

async function onInitialPageLoad() {
  try {
    showQrCode.value = false;
    await loadTenantInfoLite();
    if (tenantModule.tenantInfoLite) {
      defaultLanguageCode.value =
        tenantModule.tenantInfoLite.defaultLanguageCode;
      tenantLogoUrl.value = tenantModule.tenantInfoLite.logo || null;
      tenantLogoGuid.value = tenantModule.tenantInfoLite.logoGuid || null;
      customDisclaimer.value = tenantModule.tenantInfoLite.customDisclaimer;
    }

    await getDisclaimerTarget();
    if (disclaimerTarget.value) {
      if (
        disclaimerTarget.value.shortUrlDto &&
        'VIBER' == disclaimerTarget.value.shortUrlDto.channelType
      ) {
        shortUrlModule.setShortUrlResult(disclaimerTarget.value.shortUrlDto);
        router.push({
          name: 'viber_discl',
          query: route.query
        });
        return;
      }

      if (disclaimerTarget.value.dataPrivacyUrl) {
        dataPrivacyUrl.value = disclaimerTarget.value.dataPrivacyUrl;
      }

      contactDisclaimer.value =
        disclaimerTarget.value.shortUrlDto.contactDisclaimer;
      talentPoolDisclaimer.value =
        disclaimerTarget.value.shortUrlDto.talentPoolDisclaimer || false;
    }

    if (
      isMobileDevice() &&
      disclaimerTarget.value &&
      disclaimerTarget.value.shortUrlDto &&
      disclaimerTarget.value.shortUrlDto.directAccess
    ) {
      handleDirectAccess(disclaimerTarget.value);
    } else {
      if (
        disclaimerTarget.value &&
        disclaimerTarget.value.shortUrlDto &&
        !disclaimerTarget.value.shortUrlDto.hideDisclaimer
      ) {
        if (
          !isMobileDevice() ||
          !customDisclaimer.value ||
          (customDisclaimer.value && hideDisclaimerCheckbox.value)
        ) {
          showDisclaimerText.value = true;
        }
      }
      showSubmitBtn.value = true;
    }
  } catch (error) {
    console.log(error);
  }
}

function imprintUrl() {
  if (route.query.imprint) {
    return route.query.imprint as string;
  }
  if (tenantModule.tenantInfoLite && tenantModule.tenantInfoLite.imprintUrl) {
    return tenantModule.tenantInfoLite.imprintUrl;
  }

  return '';
}

function handleDirectAccess(target: DisclaimerTargetResponse) {
  const redirectTarget =
    (target.shortUrlDto.directAccessRedirectUrl as string) +
    target.shortUrlDto.directAccessFirstMessageText +
    ' ';
  redirectUrl.value = redirectTarget;
  alternateUrl.value =
    (target.shortUrlDto.alternateAccessRedirectUrl as string) +
    target.shortUrlDto.directAccessFirstMessageText +
    ' ';
  handleRedirect(redirectTarget);
}

async function getDisclaimerTarget() {
  try {
    disclaimerTarget.value = await shortUrlModule.doGetDisclaimerTarget(
      getShortUrlRequest()
    );
  } catch (error) {
    console.log(error);
    router.replace({ name: 'error' });
  }
}

function getShortUrlRequest(): ShortUrlRequest {
  setCookie();
  const request: ShortUrlRequest = {
    guid: route.query.id as string,
    externalCall:
      route.query && route.query.extcall
        ? (route.query.extcall as unknown as boolean)
        : false,
    apiCall:
      route.query && route.query.apicall
        ? (route.query.apicall as unknown as boolean)
        : false,
    jkey:
      route.query && route.query.jkey
        ? (route.query.jkey as string)
        : undefined,
    languageCode: currentLanguage(),
    countryCode: navigator.language,
    additionalParams: JSON.stringify(route.query),
    disclaimerGuid: disclaimerGuid.value,
    platformType: getPlatform(),
    directRedirect:
      disclaimerTarget.value && disclaimerTarget.value.shortUrlDto
        ? disclaimerTarget.value.shortUrlDto.hideDisclaimer
        : false
  };

  if (route.query.utm_source) {
    request.utm_source = (route.query.utm_source as string) || undefined;
  }

  if (route.query.utm_medium) {
    request.utm_medium = (route.query.utm_medium as string) || undefined;
  }

  if (route.query.utm_campaign) {
    request.utm_campaign = (route.query.utm_campaign as string) || undefined;
  }

  if (route.query.utm_content) {
    request.utm_content = (route.query.utm_content as string) || undefined;
  }

  if (route.query.title) {
    request.title = (route.query.title as string) || undefined;
  }
  if (route.query.company) {
    request.company = (route.query.company as string) || undefined;
  }

  if (route.query.externalJobId) {
    request.externalJobId = (route.query.externalJobId as string) || undefined;
  }

  request.channelType = 'WB';
  request.userAgent = navigator.userAgent;
  return request;
}

function setCookie(): void {
  disclaimerGuid.value = Cookies.get('disclaimerGuid');
  if (!disclaimerGuid.value) {
    getGuidCookie();
    if (disclaimerGuid.value) {
      Cookies.set('disclaimerGuid', disclaimerGuid.value);
    }
  }
}

function getPlatform(): string {
  if (Platform.is.desktop) {
    return 'DESKTOP';
  } else if (Platform.is.ios) {
    return 'IOS';
  } else if (Platform.is.android) {
    return 'ANDROID';
  } else if (Platform.is.chrome || Platform.is.edge) {
    return 'CHROME';
  } else {
    return 'FIREFOX';
  }
}

function currentLanguage(): string {
  if (language.value && language.value.length > 2) {
    return language.value.substring(0, 2);
  }

  return language.value;
}

async function loadTenantInfoLite() {
  try {
    const tenant = tenantModule.tenantInfoLite || null;
    if (!tenant) {
      await tenantModule.loadTenantInfoLite(locale.value);
    }
    if (tenantModule.tenantInfoLite) {
      let enableWhatsApp = tenantModule.tenantInfoLite.enableWhatsapp;
      let readOnlyTenant = tenantModule.tenantInfoLite.readonly;
      let salesTokenSet = route.query.sid || route.params.sid;
      tenantModule.tenantInfoLite.hideClientDataSecurity;
      if (!enableWhatsApp || (readOnlyTenant && !salesTokenSet)) {
        router.replace({ name: 'home' });
      } else {
        if (
          salesTokenSet &&
          !(await privacyConfirmModule.validateTestUserToken(
            salesTokenSet as string
          ))
        ) {
          router.replace({ name: 'home' });
        }
      }
      tenantDataPrivacyUrl.value =
        tenantModule.tenantInfoLite.dataPrivacyUrl || null;
      tenantName.value = tenantModule.tenantInfoLite.name || null;
      tenantIdentifier.value = tenantModule.tenantInfoLite.identifier || null;
      hideDisclaimerCheckbox.value =
        tenantModule.tenantInfoLite.hideDisclaimerCheckbox || false;
      if (hideDisclaimerCheckbox.value) {
        acceptWhatsappDataPrivacy.value = true;
        acceptTalentPool.value = true;
      }
      tenantInfoLoaded.value = true;
    }
  } catch (error) {
    router.replace({ name: 'home' });
    console.log(error);
  }
}

async function onApplyDisclaimer() {
  if (!acceptWhatsappDataPrivacy.value) {
    return;
  }

  if (talentPoolDisclaimer.value && !acceptTalentPool.value) {
    return;
  }
  try {
    showWhatsAppWaiting.value = true;
    showWhatsAppSpinner.value = true;
    await applyDisclaimer();
    if (disclaimerTarget.value) {
      handleDirectAccess(disclaimerTarget.value);
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  } catch (error) {
    console.log(error);
    showErrorMsgToast(t('message.failedProcessMsg') as string);
  }
  showWhatsAppSpinner.value = false;
}

function handleModelUpdate(value: boolean) {
  nextTick(() => {
    if (value) {
      onApplyDisclaimer();
    }
  });
}

async function onSubmitApply() {
  try {
    if (isMobileDevice()) {
      if (
        disclaimerTarget.value &&
        disclaimerTarget.value.shortUrlDto &&
        disclaimerTarget.value.shortUrlDto.hideDisclaimer
      ) {
        showWhatsAppWaiting.value = true;
        showDisclaimerOverlay.value = true;
        showWhatsAppSpinner.value = true;
        await getDisclaimerTarget();
        handleDirectAccess(disclaimerTarget.value);
      } else {
        if (acceptWhatsappDataPrivacy.value) {
          showWhatsAppWaiting.value = true;
          showDisclaimerOverlay.value = true;
          showWhatsAppSpinner.value = true;
          await applyDisclaimer();
          if (disclaimerTarget.value) {
            handleDirectAccess(disclaimerTarget.value);
          } else {
            showErrorMsgToast(t('message.failedProcessMsg') as string);
          }
        } else {
          showDisclaimerOverlay.value = true;
        }
      }
    } else {
      if (
        (acceptWhatsappDataPrivacy.value && !talentPoolDisclaimer.value) ||
        (acceptWhatsappDataPrivacy.value &&
          talentPoolDisclaimer.value &&
          acceptTalentPool.value) ||
        (disclaimerTarget.value &&
          disclaimerTarget.value.shortUrlDto &&
          disclaimerTarget.value.shortUrlDto.hideDisclaimer)
      ) {
        showSubmitBtn.value = false;
        showWhatsAppSpinner.value = true;
        showQrCodePanel.value = true;
        if (
          disclaimerTarget.value &&
          disclaimerTarget.value.shortUrlDto &&
          !disclaimerTarget.value.shortUrlDto.hideDisclaimer
        ) {
          await applyDisclaimer();
        } else if (
          disclaimerTarget.value &&
          disclaimerTarget.value.shortUrlDto &&
          disclaimerTarget.value.shortUrlDto.hideDisclaimer
        ) {
          await getDisclaimerTarget();
        }

        if (disclaimerTarget.value) {
          handleDirectAccess(disclaimerTarget.value);
          showWhatsAppSpinner.value = false;
        } else {
          showErrorMsgToast(t('message.failedProcessMsg') as string);
        }
      }
    }

    /* if (
        disclaimerTarget &&
        disclaimerTarget.shortUrlDto &&
        disclaimerTarget.shortUrlDto.hideDisclaimer &&
        isMobileDevice
      ) {
        showWhatsAppWaiting = true;
        showDisclaimerOverlay = true;
        showWhatsAppSpinner = true;
        await getDisclaimerTarget();
        handleDirectAccess(disclaimerTarget);
      } else {
        if (isMobileDevice) {
          if (acceptWhatsappDataPrivacy) {
            showWhatsAppWaiting = true;
            showDisclaimerOverlay = true;
            showWhatsAppSpinner = true;
            await applyDisclaimer();
            if (disclaimerTarget) {
              handleDirectAccess(disclaimerTarget);
            } else {
              showErrorMsgToast(
                this,
                t('message.failedProcessMsg') as string
              );
            }
          } else {
            showDisclaimerOverlay = true;
          }
        } else {
          //validate checkbox
          if (
            acceptWhatsappDataPrivacy ||
            (!isMobileDevice &&
              disclaimerTarget &&
              disclaimerTarget.shortUrlDto &&
              disclaimerTarget.shortUrlDto.hideDisclaimer)
          ) {
            showSubmitBtn = false;
            showWhatsAppSpinner = true;
            showQrCodePanel = true;
            await applyDisclaimer();
            if (disclaimerTarget) {
              handleDirectAccess(disclaimerTarget);
              showWhatsAppSpinner = false;
            } else {
              showErrorMsgToast(
                this,
                t('message.failedProcessMsg') as string
              );
            }
          }
        }
      } */
  } catch (error) {
    console.log(error);
    showErrorMsgToast(t('message.failedProcessMsg') as string);
  }

  showWhatsAppSpinner.value = false;
}

async function applyDisclaimer() {
  try {
    const request: ShortUrlRequest = getShortUrlRequest();
    request.dataPrivacyUrl = dataPrivacyUrl.value as string;
    if (talentPoolDisclaimer.value && acceptTalentPool.value) {
      request.acceptTalentPool = true;
    }
    disclaimerTarget.value = await shortUrlModule.doApplyDisclaimer(request);
  } catch (error) {
    console.log(error);
  }
}

async function getGuidCookie() {
  disclaimerGuid.value = (
    Math.random().toString(36).substring(2, 6) +
    Math.random().toString(36).substring(2, 6)
  ).toUpperCase();
}

function onAnyChange() {
  showQrCode.value = false;
  qrCodeLink.value = '';
}

function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function handleRedirect(redirectUri: string): void {
  if (isMobileDevice()) {
    try {
      setTimeout(() => {
        if (!document.hidden) {
          showOpenWhatsAppBtn.value = true;
        }
      }, 1000);
      window.location.href = redirectUri;
    } catch (error) {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
      window.location.href = redirectUri;
    }
  } else {
    qrCodeLink.value = redirectUri;
    showQrCode.value = true;
  }
}

function handleRedirectFromBtn(): void {
  let url = useDirectUrl.value ? redirectUrl.value : alternateUrl.value;
  if (useWindowOpen.value) {
    window.open(url, '_system');
  } else {
    useDirectUrl.value = !useDirectUrl.value;
    window.location.href = url;
  }
  useWindowOpen.value = !useWindowOpen.value;

  // if (firstRedirect.value) {
  //   firstRedirect.value = false;
  //   window.open(redirectUrl.value, '_system');
  // } else {
  //   window.location.href = redirectUrl.value;
  // }
}

function showProcessError(): void {
  $q.notify({
    color: 'pink-7',
    icon: 'warning',
    position: 'top',
    message: t('message.failedProcessMsg') as string
  });
}

function isMobileDevice(): boolean {
  return $q.platform.is.mobile || false;
}

function desktopBgImageHeight() {
  if (showDisclaimerText.value && showSubmitBtn) {
    return {
      height: $q.screen.height - 200 + 'px'
    };
  }

  if (showSubmitBtn.value) {
    return {
      height: $q.screen.height - 105 + 'px'
    };
  }

  return {
    height: $q.screen.height - 45 + 'px'
  };
}

function contentHeight() {
  if (showDisclaimerText.value && showSubmitBtn) {
    return {
      height: $q.screen.height - 200 + 'px'
    };
  }

  if (showSubmitBtn.value) {
    return {
      height: $q.screen.height - 105 + 'px'
    };
  }

  return {
    height: $q.screen.height - 45 + 'px'
  };
}

function swipeAreaContentHeight() {
  return {
    height: $q.screen.height - 350 + 'px'
  };
}

function swipableContentHeight() {
  return $q.screen.height - 250 + 'px';
}

function disclaimerOnlyPageStyle() {
  return {
    height: $q.screen.height + 'px'
  };
}

function dataPrivacyLabel() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.dataPrivacyLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.dataPrivacyLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_') //replaceAll('-', '_')
      );
    }
  }

  return t('message.dataPrivacyLbl');
}

function dataPrivacyFrameworkUrl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.dataPrivacyFrameworkUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.dataPrivacyFrameworkUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }

  return t('message.dataPrivacyFrameworkUrl');
}
function dataPrivacyFrameworkLabel() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.dataPrivacyFrameworkLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.dataPrivacyFrameworkLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }

  return t('message.dataPrivacyFrameworkLbl');
}

function privacyShieldUrl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.privacyShieldUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.privacyShieldUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }

  return t('message.privacyShieldUrl');
}
function privacyShieldLabel() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.privacyShieldLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.privacyShieldLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.privacyShieldLbl');
}

function addnlTermsOfUsageUrl() {
  if (tenantModule.tenantInfoLite) {
    if (tenantModule.tenantInfoLite.ps) {
      return t('message.addnlTermsOfUsageUrl_prescreen');
    }
    if (
      te(
        'message.addnlTermsOfUsageUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.addnlTermsOfUsageUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }

  return termsOfUseLink();
}
function addnlTermsOfUsageLbl() {
  if (tenantModule.tenantInfoLite) {
    if (tenantModule.tenantInfoLite.ps) {
      return t('message.addnlTermsOfUsageLbl_prescreen');
    }
    if (
      te(
        'message.addnlTermsOfUsageLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.addnlTermsOfUsageLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.addnlTermsOfUsageLbl');
}

function addnlTermsLbl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.addnlTermsLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.addnlTermsLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.moreInformationLabel');
}

function whatsAppDataPrivacyLbl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.whatsAppDataPrivacyLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.whatsAppDataPrivacyLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.whatsAppDataPrivacyLbl');
}

function whatsAppDataPrivacyUrl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.whatsAppDataPrivacyUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.whatsAppDataPrivacyUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.defaultWhatsAppDataPrivacyUrl');
}

function whatsAppTermsOfUsageUrl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.whatsAppTermsOfUsageUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.whatsAppTermsOfUsageUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.defaultWhatsAppTermsOfUsageUrl');
}
function whatsAppTermsOfUsageLbl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.whatsAppTermsOfUsageLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.whatsAppTermsOfUsageLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.whatsAppTermsOfUsageLbl');
}
function handleImageError(event: any) {
  event.target.style.display = 'none'; // Hide the image if it fails to load
}

function startChartOptionLbl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.startChartOptionLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.startChartOptionLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.startChartOptionLbl');
}

return (_ctx: any,_cache: any) => {
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_q_field = _resolveComponent("q-field")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_qrcode = _resolveComponent("qrcode")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref($q).platform.is.mobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!showDisclaimerOverlay.value)
            ? (_openBlock(), _createBlock(_component_q_layout, {
                key: 0,
                view: "hHh lpR fFf"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_header, { elevated: "" }, {
                    default: _withCtx(() => [
                      (tenantLogoGuid.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_q_toolbar, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  _createElementVNode("div", _hoisted_4, [
                                    (tenantLogoGuid.value)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: _unref(logoPath) + tenantLogoGuid.value,
                                          class: "q-mr-xs tenant-logo",
                                          onError: handleImageError
                                        }, null, 40, _hoisted_5))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, _toDisplayString(tenantName.value), 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_q_toolbar, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('message.designDisclaimerHeader')), 1),
                                  _hoisted_11
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_page_container, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "bg-image row full-width items-center justify-center",
                        style: _normalizeStyle(contentHeight())
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_q_carousel, {
                            modelValue: currentIndex.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentIndex).value = $event)),
                            "transition-prev": "slide-right",
                            "transition-next": "slide-left",
                            swipeable: "",
                            animated: "",
                            "control-color": "white",
                            "prev-icon": "arrow_left",
                            "next-icon": "arrow_right",
                            navigation: "",
                            padding: "",
                            height: "60vh",
                            class: "text-white shadow-2 custom-area bg-whatsapp",
                            style: _normalizeStyle(swipableAreaStyle())
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_carousel_slide, {
                                name: "1",
                                class: "column no-wrap flex-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_13,
                                  _createElementVNode("div", _hoisted_14, _toDisplayString(step1Text()), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_carousel_slide, { name: "2" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_q_avatar, {
                                      class: "bg-whatsapp text-bold shadow-4",
                                      size: "50px",
                                      "font-size": "26px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("1.")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('message.designDisclaimerStep2_1Text')) + " ", 1),
                                      (showDisclaimerText.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('message.designDisclaimerStep2_2Text')), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _hoisted_19
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_carousel_slide, { name: "3" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createVNode(_component_q_avatar, {
                                      class: "bg-whatsapp text-bold shadow-4",
                                      size: "50px",
                                      "font-size": "26px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("2.")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('message.designDisclaimerStep3_1Text')), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.designDisclaimerStep3_2Text')), 1)
                                    ]),
                                    _hoisted_24
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_carousel_slide, { name: "4" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createVNode(_component_q_avatar, {
                                      class: "bg-whatsapp text-bold shadow-4",
                                      size: "50px",
                                      "font-size": "26px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("3.")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('message.designDisclaimerStep4_1Text')) + " ", 1),
                                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('message.designDisclaimerStep4_2Text')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("img", {
                                        src: chatImageSrc(),
                                        draggable: "false",
                                        style: {"max-width":"100%"}
                                      }, null, 8, _hoisted_30)
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_carousel_slide, { name: "5" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                      _createVNode(_component_q_avatar, {
                                        class: "bg-whatsapp text-bold shadow-4",
                                        size: "50px",
                                        "font-size": "26px"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("4.")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("div", _hoisted_34, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('message.designDisclaimerStep5_1Text')) + " ", 1),
                                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('message.designDisclaimerStep5Text')), 1)
                                      ]),
                                      _hoisted_36
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", {
                                      class: "bg-whatsapp corners row items-center justify-center full-width shadow-2",
                                      style: {"font-size":"1.2rem","height":"40px"},
                                      onClick: onSubmitApply
                                    }, _toDisplayString(_ctx.$t('message.designDisclaimerStep5_2Text')), 1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "style"])
                        ])
                      ], 4)
                    ]),
                    _: 1
                  }),
                  (showDisclaimerText.value || showSubmitBtn.value)
                    ? (_openBlock(), _createBlock(_component_q_footer, {
                        key: 0,
                        elevated: "",
                        style: {"background-color":"#b2b2b2"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_slide_transition, { appear: "" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                (showDisclaimerText.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      _createElementVNode("div", _hoisted_39, [
                                        (!hideDisclaimerCheckbox.value)
                                          ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                              key: 0,
                                              disable: showQrCode.value,
                                              size: "lg",
                                              "onUpdate:modelValue": [
                                                onAnyChange,
                                                _cache[1] || (_cache[1] = ($event: any) => ((acceptWhatsappDataPrivacy).value = $event))
                                              ],
                                              modelValue: acceptWhatsappDataPrivacy.value,
                                              dark: "",
                                              color: "whatsapp"
                                            }, null, 8, ["disable", "modelValue"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", {
                                        class: "col text-white",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (
                    !hideDisclaimerCheckbox.value && !showQrCode.value
                      ? (acceptWhatsappDataPrivacy.value = !acceptWhatsappDataPrivacy.value)
                      : true
                  ))
                                      }, [
                                        _createVNode(_component_q_field, {
                                          style: {"font-size":"0.55rem !important"},
                                          borderless: "",
                                          dense: "",
                                          "hide-bottom-space": "",
                                          color: "white",
                                          ref: "acceptWhatsappDataPrivacyRef",
                                          value: acceptWhatsappDataPrivacy.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_40, [
                                              _createVNode(_component_i18n_t, {
                                                keypath: dataPrivacyText(),
                                                tag: "div"
                                              }, {
                                                termsOfUsageUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: termsOfUseLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.termsOfUseLbl')), 9, _hoisted_41)
                                                ]),
                                                addnlTermsOfUsageUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: addnlTermsOfUsageUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(addnlTermsOfUsageLbl()), 9, _hoisted_42)
                                                ]),
                                                pitchYouTermsOfUsageUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: termsOfUseLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.pitchYouTermsOfUseLbl')), 9, _hoisted_43)
                                                ]),
                                                dataPrivacyUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: dataPrivacyLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(dataPrivacyLabel()), 9, _hoisted_44)
                                                ]),
                                                dataPrivacyFrameworkUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: dataPrivacyFrameworkUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(dataPrivacyFrameworkLabel), 8, _hoisted_45)
                                                ]),
                                                privacyShieldUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: privacyShieldUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(privacyShieldLabel()), 9, _hoisted_46)
                                                ]),
                                                dataPrivacyInfoUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: dataPrivacyLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.dataPrivacyInfoLbl')), 9, _hoisted_47)
                                                ]),
                                                dataPrivacyUrlAlt: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: dataPrivacyLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.dataPrivacyLblAlt')), 9, _hoisted_48)
                                                ]),
                                                additionalTermsUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: additionalTermsLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(addnlTermsLbl()), 9, _hoisted_49)
                                                ]),
                                                additionalTermsUrlAlt: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: additionalTermsLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.moreInformationLabelAlt')), 9, _hoisted_50)
                                                ]),
                                                imprintUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: imprintUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_51)
                                                ]),
                                                pitchyouDisclaimer: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.defaultDataPrivacyLink'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.dataPrivacyLbl')), 9, _hoisted_52)
                                                ]),
                                                pitchyouImprint: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.defaultImprintLink'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_53)
                                                ]),
                                                pitchyouTermsOfUse: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.defaultTermsOfUseLink'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.termsOfUseLbl')), 9, _hoisted_54)
                                                ]),
                                                whatsAppDisclaimer: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.defaultWhatsAppDataPrivacyLink'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.dataPrivacyTitle')), 9, _hoisted_55)
                                                ]),
                                                whatsAppDataPrivacyUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: whatsAppDataPrivacyUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(whatsAppDataPrivacyLbl()), 9, _hoisted_56)
                                                ]),
                                                whatsAppTermsOfUsageUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: whatsAppTermsOfUsageUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(whatsAppTermsOfUsageLbl()), 9, _hoisted_57)
                                                ]),
                                                newLine: _withCtx(() => [
                                                  _hoisted_58
                                                ]),
                                                tcDataPrivacy: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.tcDataPrivacy'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.dataPrivacyLbl')), 9, _hoisted_59)
                                                ]),
                                                tcImprint: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.tcImprint'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_60)
                                                ]),
                                                _: 1
                                              }, 8, ["keypath"])
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (showSubmitBtn.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                      _createElementVNode("div", {
                                        class: "bg-whatsapp corners text-white justify-center row items-center wrapping text-center q-mr-sm q-ml-sm q-mb-sm shadow-4",
                                        style: {"font-size":"1.1rem !important","height":"50px","padding":"0 10px","display":"flex","align-items":"center","justify-content":"center"},
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (onSubmitApply()))
                                      }, [
                                        (tenantLogoGuid.value)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_62))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_63, _toDisplayString(startButtonText()), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  (showWhatsAppWaiting.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _createElementVNode("div", {
                          style: _normalizeStyle(disclaimerOnlyPageStyle())
                        }, [
                          _hoisted_67,
                          (showWhatsAppSpinner.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                _createVNode(_component_q_spinner, {
                                  color: "whatsapp",
                                  size: "xl"
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (showOpenWhatsAppBtn.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                _createVNode(_component_q_btn, {
                                  class: "q-pr-lg q-pl-lg",
                                  rounded: "",
                                  "no-caps": "",
                                  color: "whatsapp",
                                  size: "xl",
                                  label: _ctx.$t('message.openLbl'),
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (handleRedirectFromBtn()))
                                }, null, 8, ["label"])
                              ]))
                            : _createCommentVNode("", true)
                        ], 4)
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "column justify-between",
                        style: _normalizeStyle(disclaimerOnlyPageStyle())
                      }, [
                        (customDisclaimer.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_q_btn, {
                                  round: "",
                                  flat: "",
                                  "bg-transparent": "",
                                  icon: "close",
                                  class: "text-white",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showDisclaimerOverlay.value = !showDisclaimerOverlay.value))
                                })
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _createElementVNode("div", _hoisted_72, [
                                  _createTextVNode(_toDisplayString(additonalText1()) + " ", 1),
                                  (additionalText2())
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(additionalText2()), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_74, [
                                  (!hideDisclaimerCheckbox.value)
                                    ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                        key: 0,
                                        disable: showQrCode.value,
                                        class: "col-2",
                                        size: "lg",
                                        "onUpdate:modelValue": [
                                          handleModelUpdate,
                                          _cache[6] || (_cache[6] = ($event: any) => ((acceptWhatsappDataPrivacy).value = $event))
                                        ],
                                        modelValue: acceptWhatsappDataPrivacy.value,
                                        dark: "",
                                        color: "whatsapp"
                                      }, null, 8, ["disable", "modelValue"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_75, [
                                    _createVNode(_component_q_field, {
                                      style: {"font-size":"0.55rem !important"},
                                      borderless: "",
                                      dense: "",
                                      "hide-bottom-space": "",
                                      color: "white"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_i18n_t, {
                                            keypath: dataPrivacyText(),
                                            tag: "div"
                                          }, {
                                            termsOfUsageUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: termsOfUseLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.termsOfUseLbl')), 9, _hoisted_76)
                                            ]),
                                            addnlTermsOfUsageUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: addnlTermsOfUsageUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(addnlTermsOfUsageLbl()), 9, _hoisted_77)
                                            ]),
                                            pitchYouTermsOfUsageUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: termsOfUseLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.pitchYouTermsOfUseLbl')), 9, _hoisted_78)
                                            ]),
                                            dataPrivacyUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: dataPrivacyLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(dataPrivacyLabel()), 9, _hoisted_79)
                                            ]),
                                            dataPrivacyFrameworkUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: dataPrivacyFrameworkUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(dataPrivacyFrameworkLabel()), 9, _hoisted_80)
                                            ]),
                                            privacyShieldUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: privacyShieldUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(privacyShieldLabel()), 9, _hoisted_81)
                                            ]),
                                            dataPrivacyInfoUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: dataPrivacyLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.dataPrivacyInfoLbl')), 9, _hoisted_82)
                                            ]),
                                            dataPrivacyUrlAlt: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: dataPrivacyLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.dataPrivacyLblAlt')), 9, _hoisted_83)
                                            ]),
                                            additionalTermsUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: additionalTermsLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(addnlTermsLbl()), 9, _hoisted_84)
                                            ]),
                                            additionalTermsUrlAlt: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: additionalTermsLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.moreInformationLabelAlt')), 9, _hoisted_85)
                                            ]),
                                            imprintUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: imprintUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_86)
                                            ]),
                                            pitchyouDisclaimer: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: _ctx.$t('message.defaultDataPrivacyLink'),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.dataPrivacyLbl')), 9, _hoisted_87)
                                            ]),
                                            pitchyouImprint: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: _ctx.$t('message.defaultImprintLink'),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_88)
                                            ]),
                                            pitchyouTermsOfUse: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: _ctx.$t('message.defaultTermsOfUseLink'),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.termsOfUseLbl')), 9, _hoisted_89)
                                            ]),
                                            whatsAppDisclaimer: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: 
                                _ctx.$t('message.defaultWhatsAppDataPrivacyLink')
                              ,
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.dataPrivacyTitle')), 9, _hoisted_90)
                                            ]),
                                            whatsAppDataPrivacyUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: whatsAppDataPrivacyUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(whatsAppDataPrivacyLbl()), 9, _hoisted_91)
                                            ]),
                                            whatsAppTermsOfUsageUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: whatsAppTermsOfUsageUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(whatsAppTermsOfUsageLbl()), 9, _hoisted_92)
                                            ]),
                                            newLine: _withCtx(() => [
                                              _hoisted_93
                                            ]),
                                            tcDataPrivacy: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: _ctx.$t('message.tcDataPrivacy'),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.dataPrivacyLbl')), 9, _hoisted_94)
                                            ]),
                                            tcImprint: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: _ctx.$t('message.tcImprint'),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_95)
                                            ]),
                                            _: 1
                                          }, 8, ["keypath"])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                (talentPoolDisclaimer.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                      (!hideDisclaimerCheckbox.value)
                                        ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                            key: 0,
                                            disable: showQrCode.value,
                                            class: "col-2",
                                            size: "lg",
                                            "onUpdate:modelValue": [
                                              handleModelUpdate,
                                              _cache[7] || (_cache[7] = ($event: any) => ((acceptTalentPool).value = $event))
                                            ],
                                            modelValue: acceptTalentPool.value,
                                            dark: "",
                                            color: "whatsapp"
                                          }, null, 8, ["disable", "modelValue"]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_97, [
                                        _createVNode(_component_q_field, {
                                          style: {"font-size":"0.55rem !important"},
                                          borderless: "",
                                          dense: "",
                                          "hide-bottom-space": "",
                                          color: "white"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                              _createVNode(_component_i18n_t, {
                                                keypath: 'message.talentPoolDisclaimerText',
                                                tag: "div"
                                              }, {
                                                dataPrivacyUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: dataPrivacyLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(dataPrivacyLabel()), 9, _hoisted_98)
                                                ]),
                                                dataPrivacyFrameworkUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: dataPrivacyFrameworkUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(dataPrivacyFrameworkLabel()), 9, _hoisted_99)
                                                ]),
                                                privacyShieldUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: privacyShieldUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(privacyShieldLabel()), 9, _hoisted_100)
                                                ]),
                                                _: 1
                                              }, 8, ["keypath"])
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (additionalText3())
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                      _createVNode(_component_i18n_t, {
                                        keypath: additionalText3(),
                                        tag: "div"
                                      }, {
                                        termsOfUsageUrl: _withCtx(() => [
                                          _createElementVNode("a", {
                                            href: termsOfUseLink(),
                                            target: "_blank",
                                            class: "text-white"
                                          }, _toDisplayString(_ctx.$t('message.termsOfUseLbl')), 9, _hoisted_102)
                                        ]),
                                        addnlTermsOfUsageUrl: _withCtx(() => [
                                          _createElementVNode("a", {
                                            href: addnlTermsOfUsageUrl(),
                                            target: "_blank",
                                            class: "text-white"
                                          }, _toDisplayString(addnlTermsOfUsageLbl()), 9, _hoisted_103)
                                        ]),
                                        pitchYouTermsOfUsageUrl: _withCtx(() => [
                                          _createElementVNode("a", {
                                            href: termsOfUseLink(),
                                            target: "_blank",
                                            class: "text-white"
                                          }, _toDisplayString(_ctx.$t('message.pitchYouTermsOfUseLbl')), 9, _hoisted_104)
                                        ]),
                                        dataPrivacyUrl: _withCtx(() => [
                                          _createElementVNode("a", {
                                            href: dataPrivacyLink(),
                                            target: "_blank",
                                            class: "text-white"
                                          }, _toDisplayString(dataPrivacyLabel()), 9, _hoisted_105)
                                        ]),
                                        dataPrivacyFrameworkUrl: _withCtx(() => [
                                          _createElementVNode("a", {
                                            href: dataPrivacyFrameworkUrl(),
                                            target: "_blank",
                                            class: "text-white"
                                          }, _toDisplayString(dataPrivacyFrameworkLabel()), 9, _hoisted_106)
                                        ]),
                                        privacyShieldUrl: _withCtx(() => [
                                          _createElementVNode("a", {
                                            href: privacyShieldUrl(),
                                            target: "_blank",
                                            class: "text-white"
                                          }, _toDisplayString(privacyShieldLabel()), 9, _hoisted_107)
                                        ]),
                                        dataPrivacyInfoUrl: _withCtx(() => [
                                          _createElementVNode("a", {
                                            href: dataPrivacyLink(),
                                            target: "_blank",
                                            class: "text-white"
                                          }, _toDisplayString(_ctx.$t('message.dataPrivacyInfoLbl')), 9, _hoisted_108)
                                        ]),
                                        dataPrivacyUrlAlt: _withCtx(() => [
                                          _createElementVNode("a", {
                                            href: dataPrivacyLink(),
                                            target: "_blank",
                                            class: "text-white"
                                          }, _toDisplayString(_ctx.$t('message.dataPrivacyLblAlt')), 9, _hoisted_109)
                                        ]),
                                        _: 1
                                      }, 8, ["keypath"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!customDisclaimer.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_q_btn, {
                                  round: "",
                                  flat: "",
                                  "bg-transparent": "",
                                  icon: "close",
                                  class: "text-white",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (showDisclaimerOverlay.value = !showDisclaimerOverlay.value))
                                })
                              ]),
                              _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("div", _hoisted_112, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('message.designDisclaimerAdditionalText1')) + " ", 1),
                                  _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.$t('message.designDisclaimerAdditionalText2')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_114, [
                                  (!hideDisclaimerCheckbox.value)
                                    ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                        key: 0,
                                        disable: showQrCode.value,
                                        class: "col-2",
                                        size: "lg",
                                        "onUpdate:modelValue": [
                                          handleModelUpdate,
                                          _cache[9] || (_cache[9] = ($event: any) => ((acceptWhatsappDataPrivacy).value = $event))
                                        ],
                                        modelValue: acceptWhatsappDataPrivacy.value,
                                        dark: "",
                                        color: "whatsapp"
                                      }, null, 8, ["disable", "modelValue"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_115, [
                                    _createVNode(_component_q_field, {
                                      style: {"font-size":"0.55rem !important"},
                                      borderless: "",
                                      dense: "",
                                      "hide-bottom-space": "",
                                      color: "white"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_i18n_t, {
                                            keypath: dataPrivacyText(),
                                            tag: "div"
                                          }, {
                                            termsOfUsageUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: termsOfUseLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.termsOfUseLbl')), 9, _hoisted_116)
                                            ]),
                                            addnlTermsOfUsageUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: addnlTermsOfUsageUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(addnlTermsOfUsageLbl()), 9, _hoisted_117)
                                            ]),
                                            pitchYouTermsOfUsageUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: termsOfUseLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.pitchYouTermsOfUseLbl')), 9, _hoisted_118)
                                            ]),
                                            dataPrivacyUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: dataPrivacyLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(dataPrivacyLabel()), 9, _hoisted_119)
                                            ]),
                                            dataPrivacyFrameworkUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: dataPrivacyFrameworkUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(dataPrivacyFrameworkLabel()), 9, _hoisted_120)
                                            ]),
                                            privacyShieldUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: privacyShieldUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(privacyShieldLabel()), 9, _hoisted_121)
                                            ]),
                                            dataPrivacyInfoUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: dataPrivacyLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.dataPrivacyInfoLbl')), 9, _hoisted_122)
                                            ]),
                                            dataPrivacyUrlAlt: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: dataPrivacyLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.dataPrivacyLblAlt')), 9, _hoisted_123)
                                            ]),
                                            additionalTermsUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: additionalTermsLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(addnlTermsLbl()), 9, _hoisted_124)
                                            ]),
                                            additionalTermsUrlAlt: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: additionalTermsLink(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.moreInformationLabelAlt')), 9, _hoisted_125)
                                            ]),
                                            imprintUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: imprintUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_126)
                                            ]),
                                            pitchyouDisclaimer: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: _ctx.$t('message.defaultDataPrivacyLink'),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.dataPrivacyLbl')), 9, _hoisted_127)
                                            ]),
                                            pitchyouImprint: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: _ctx.$t('message.defaultImprintLink'),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_128)
                                            ]),
                                            pitchyouTermsOfUse: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: _ctx.$t('message.defaultTermsOfUseLink'),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.termsOfUseLbl')), 9, _hoisted_129)
                                            ]),
                                            whatsAppDisclaimer: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: 
                                _ctx.$t('message.defaultWhatsAppDataPrivacyLink')
                              ,
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.dataPrivacyTitle')), 9, _hoisted_130)
                                            ]),
                                            whatsAppDataPrivacyUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: whatsAppDataPrivacyUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(whatsAppDataPrivacyLbl()), 9, _hoisted_131)
                                            ]),
                                            whatsAppTermsOfUsageUrl: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: whatsAppTermsOfUsageUrl(),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(whatsAppTermsOfUsageLbl()), 9, _hoisted_132)
                                            ]),
                                            newLine: _withCtx(() => [
                                              _hoisted_133
                                            ]),
                                            tcDataPrivacy: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: _ctx.$t('message.tcDataPrivacy'),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.dataPrivacyLbl')), 9, _hoisted_134)
                                            ]),
                                            tcImprint: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: _ctx.$t('message.tcImprint'),
                                                target: "_blank",
                                                class: "text-white"
                                              }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_135)
                                            ]),
                                            _: 1
                                          }, 8, ["keypath"])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 4))
                ])
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_136, [
          (!showDisclaimerOverlay.value)
            ? (_openBlock(), _createBlock(_component_q_layout, {
                key: 0,
                view: "hHh lpR fFf"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_header, {
                    elevated: "",
                    style: {"background-color":"#b2b2b2"}
                  }, {
                    default: _withCtx(() => [
                      (tenantLogoGuid.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                            _createVNode(_component_q_toolbar, null, {
                              default: _withCtx(() => [
                                (tenantLogoGuid.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                      _createElementVNode("div", _hoisted_139, [
                                        (tenantLogoGuid.value)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: _unref(logoPath) + tenantLogoGuid.value,
                                              class: "q-mr-xs tenant-logo",
                                              onError: handleImageError
                                            }, null, 40, _hoisted_140))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_141, [
                                        _createElementVNode("div", _hoisted_142, _toDisplayString(tenantName.value), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_143, [
                            _createVNode(_component_q_toolbar, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_144, [
                                  _createElementVNode("div", _hoisted_145, _toDisplayString(_ctx.$t('message.designDisclaimerHeader')), 1),
                                  _hoisted_146
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_page_container, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "bg-image row full-width items-center justify-center",
                        style: _normalizeStyle(desktopBgImageHeight())
                      }, [
                        _createElementVNode("div", _hoisted_147, [
                          (!showQrCodePanel.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                _createElementVNode("div", _hoisted_149, [
                                  _createElementVNode("div", _hoisted_150, [
                                    _hoisted_151,
                                    _createElementVNode("div", _hoisted_152, _toDisplayString(step1Text()), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_153, [
                                  _createElementVNode("div", _hoisted_154, [
                                    _createVNode(_component_q_avatar, {
                                      class: "bg-whatsapp text-bold shadow-4",
                                      size: "50px",
                                      "font-size": "26px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("1.")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_155, [
                                    _createElementVNode("div", _hoisted_156, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('message.designDisclaimerStep2_1Text')) + " ", 1),
                                      (showDisclaimerText.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_157, _toDisplayString(_ctx.$t('message.designDisclaimerStep2_2Text')), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _hoisted_158
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_159, [
                                  _createElementVNode("div", _hoisted_160, [
                                    _createVNode(_component_q_avatar, {
                                      class: "bg-whatsapp text-bold shadow-4",
                                      size: "50px",
                                      "font-size": "26px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("2.")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_161, [
                                    _createElementVNode("div", _hoisted_162, [
                                      _createElementVNode("div", _hoisted_163, _toDisplayString(_ctx.$t('message.designDisclaimerStep3_1Text')), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.designDisclaimerStep3_2Text')), 1)
                                    ]),
                                    _hoisted_164
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_165, [
                                  _createElementVNode("div", _hoisted_166, [
                                    _createVNode(_component_q_avatar, {
                                      class: "bg-whatsapp text-bold shadow-4",
                                      size: "50px",
                                      "font-size": "26px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("3.")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_167, [
                                    _createElementVNode("div", _hoisted_168, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('message.designDisclaimerStep4_1Text')) + " ", 1),
                                      _createElementVNode("div", _hoisted_169, _toDisplayString(_ctx.$t('message.designDisclaimerStep4_2Text')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_170, [
                                      _createElementVNode("img", {
                                        src: chatImageSrc(),
                                        draggable: "false",
                                        style: {"max-width":"100%"}
                                      }, null, 8, _hoisted_171)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_172, [
                                  _createElementVNode("div", _hoisted_173, [
                                    _createVNode(_component_q_avatar, {
                                      class: "bg-whatsapp text-bold shadow-4",
                                      size: "50px",
                                      "font-size": "26px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("4.")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_174, [
                                    _createElementVNode("div", _hoisted_175, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('message.designDisclaimerStep5_1Text')) + " ", 1),
                                      _createElementVNode("div", _hoisted_176, _toDisplayString(_ctx.$t('message.designDisclaimerStep5Text')), 1)
                                    ]),
                                    _hoisted_177
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                _createElementVNode("div", _hoisted_179, [
                                  _createElementVNode("div", _hoisted_180, [
                                    (showWhatsAppSpinner.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                                          _createVNode(_component_q_spinner, {
                                            color: "whatsapp",
                                            size: "3em",
                                            thickness: 10
                                          })
                                        ]))
                                      : _createCommentVNode("", true),
                                    (showOpenWhatsAppBtn.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                                          _createVNode(_component_q_btn, {
                                            class: "q-pr-lg q-pl-lg",
                                            rounded: "",
                                            "no-caps": "",
                                            color: "whatsapp",
                                            size: "xl",
                                            label: _ctx.$t('message.openLbl'),
                                            onClick: _cache[10] || (_cache[10] = ($event: any) => (handleRedirectFromBtn()))
                                          }, null, 8, ["label"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (showQrCode.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                                          _createVNode(_component_qrcode, {
                                            value: qrCodeLink.value,
                                            options: {
                          width: 200,
                          color: { dark: '#000', light: '#eee8df' },
                          margin: 1
                        },
                                            tag: "img"
                                          }, null, 8, ["value"]),
                                          _createElementVNode("div", _hoisted_184, _toDisplayString(_ctx.$t('message.startScanLbl')), 1),
                                          _createElementVNode("a", {
                                            href: qrCodeLink.value,
                                            target: "_blank",
                                            class: "button-desktop"
                                          }, _toDisplayString(startChartOptionLbl()), 9, _hoisted_185)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                        ])
                      ], 4)
                    ]),
                    _: 1
                  }),
                  (showDisclaimerText.value || showSubmitBtn.value)
                    ? (_openBlock(), _createBlock(_component_q_footer, {
                        key: 0,
                        elevated: "",
                        style: {"background-color":"#b2b2b2"},
                        class: "row justify-center full-width"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_slide_transition, { appear: "" }, {
                            default: _withCtx(() => [
                              (showDisclaimerText.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                    _createElementVNode("div", _hoisted_187, [
                                      _createElementVNode("div", _hoisted_188, [
                                        (!hideDisclaimerCheckbox.value)
                                          ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                              key: 0,
                                              disable: showQrCode.value,
                                              size: "lg",
                                              "onUpdate:modelValue": [
                                                _cache[11] || (_cache[11] = ($event: any) => (onAnyChange())),
                                                _cache[12] || (_cache[12] = ($event: any) => ((acceptWhatsappDataPrivacy).value = $event))
                                              ],
                                              modelValue: acceptWhatsappDataPrivacy.value,
                                              dark: "",
                                              color: "whatsapp"
                                            }, null, 8, ["disable", "modelValue"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", {
                                        class: "col text-white",
                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (
                    !hideDisclaimerCheckbox.value && !showQrCode.value
                      ? (acceptWhatsappDataPrivacy.value = !acceptWhatsappDataPrivacy.value)
                      : true
                  ))
                                      }, [
                                        _createVNode(_component_q_field, {
                                          style: {"font-size":"0.7rem !important"},
                                          borderless: "",
                                          dense: "",
                                          "hide-bottom-space": "",
                                          color: "white",
                                          ref: "acceptWhatsappDataPrivacyRef",
                                          value: acceptWhatsappDataPrivacy.value,
                                          class: "cursor-pointer"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_189, [
                                              _createVNode(_component_i18n_t, {
                                                keypath: dataPrivacyText(),
                                                tag: "div"
                                              }, {
                                                termsOfUsageUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: termsOfUseLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.termsOfUseLbl')), 9, _hoisted_190)
                                                ]),
                                                addnlTermsOfUsageUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: addnlTermsOfUsageUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(addnlTermsOfUsageLbl()), 9, _hoisted_191)
                                                ]),
                                                pitchYouTermsOfUsageUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: termsOfUseLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.pitchYouTermsOfUseLbl')), 9, _hoisted_192)
                                                ]),
                                                dataPrivacyUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: dataPrivacyLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(dataPrivacyLabel()), 9, _hoisted_193)
                                                ]),
                                                dataPrivacyFrameworkUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: dataPrivacyFrameworkUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(dataPrivacyFrameworkLabel()), 9, _hoisted_194)
                                                ]),
                                                privacyShieldUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: privacyShieldUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(privacyShieldLabel()), 9, _hoisted_195)
                                                ]),
                                                dataPrivacyInfoUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: dataPrivacyLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.dataPrivacyInfoLbl')), 9, _hoisted_196)
                                                ]),
                                                dataPrivacyUrlAlt: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: dataPrivacyLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.dataPrivacyLblAlt')), 9, _hoisted_197)
                                                ]),
                                                additionalTermsUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: additionalTermsLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(addnlTermsLbl()), 9, _hoisted_198)
                                                ]),
                                                additionalTermsUrlAlt: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: additionalTermsLink(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.moreInformationLabelAlt')), 9, _hoisted_199)
                                                ]),
                                                imprintUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: imprintUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_200)
                                                ]),
                                                pitchyouDisclaimer: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.defaultDataPrivacyLink'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.dataPrivacyLbl')), 9, _hoisted_201)
                                                ]),
                                                pitchyouImprint: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.defaultImprintLink'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_202)
                                                ]),
                                                pitchyouTermsOfUse: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.defaultTermsOfUseLink'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.termsOfUseLbl')), 9, _hoisted_203)
                                                ]),
                                                whatsAppDisclaimer: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.defaultWhatsAppDataPrivacyLink'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.dataPrivacyTitle')), 9, _hoisted_204)
                                                ]),
                                                whatsAppDataPrivacyUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: whatsAppDataPrivacyUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(whatsAppDataPrivacyLbl()), 9, _hoisted_205)
                                                ]),
                                                whatsAppTermsOfUsageUrl: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: whatsAppTermsOfUsageUrl(),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(whatsAppTermsOfUsageLbl()), 9, _hoisted_206)
                                                ]),
                                                newLine: _withCtx(() => [
                                                  _hoisted_207
                                                ]),
                                                tcDataPrivacy: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.tcDataPrivacy'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.dataPrivacyLbl')), 9, _hoisted_208)
                                                ]),
                                                tcImprint: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    href: _ctx.$t('message.tcImprint'),
                                                    target: "_blank",
                                                    class: "text-white"
                                                  }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_209)
                                                ]),
                                                _: 1
                                              }, 8, ["keypath"])
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ])
                                    ]),
                                    (talentPoolDisclaimer.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                          _createElementVNode("div", _hoisted_211, [
                                            (!hideDisclaimerCheckbox.value)
                                              ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                                  key: 0,
                                                  disable: showQrCode.value,
                                                  size: "lg",
                                                  "onUpdate:modelValue": [
                                                    _cache[14] || (_cache[14] = ($event: any) => (onAnyChange())),
                                                    _cache[15] || (_cache[15] = ($event: any) => ((acceptTalentPool).value = $event))
                                                  ],
                                                  modelValue: acceptTalentPool.value,
                                                  dark: "",
                                                  color: "whatsapp"
                                                }, null, 8, ["disable", "modelValue"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", {
                                            class: "col text-white",
                                            onClick: _cache[16] || (_cache[16] = ($event: any) => (
                    !hideDisclaimerCheckbox.value && !showQrCode.value
                      ? (acceptTalentPool.value = !acceptTalentPool.value)
                      : true
                  ))
                                          }, [
                                            _createVNode(_component_q_field, {
                                              style: {"font-size":"0.7rem !important"},
                                              borderless: "",
                                              dense: "",
                                              "hide-bottom-space": "",
                                              color: "white",
                                              ref: "acceptTalentPoolRef",
                                              value: acceptTalentPool.value,
                                              class: "cursor-pointer"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_212, [
                                                  _createVNode(_component_i18n_t, {
                                                    keypath: 'message.talentPoolDisclaimerText',
                                                    tag: "div"
                                                  }, {
                                                    dataPrivacyUrl: _withCtx(() => [
                                                      _createElementVNode("a", {
                                                        href: dataPrivacyLink(),
                                                        target: "_blank",
                                                        class: "text-white"
                                                      }, _toDisplayString(dataPrivacyLabel()), 9, _hoisted_213)
                                                    ]),
                                                    dataPrivacyFrameworkUrl: _withCtx(() => [
                                                      _createElementVNode("a", {
                                                        href: dataPrivacyFrameworkUrl(),
                                                        target: "_blank",
                                                        class: "text-white"
                                                      }, _toDisplayString(dataPrivacyFrameworkLabel()), 9, _hoisted_214)
                                                    ]),
                                                    privacyShieldUrl: _withCtx(() => [
                                                      _createElementVNode("a", {
                                                        href: privacyShieldUrl(),
                                                        target: "_blank",
                                                        class: "text-white"
                                                      }, _toDisplayString(privacyShieldLabel()), 9, _hoisted_215)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["keypath"])
                                                ])
                                              ]),
                                              _: 1
                                            }, 8, ["value"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (showSubmitBtn.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
                                          _createElementVNode("div", {
                                            class: "bg-whatsapp corners text-white justify-center row items-center wrapping text-center q-mr-sm q-ml-sm q-mb-sm shadow-4 cursor-pointer",
                                            style: {"font-size":"1.1rem !important","height":"50px"},
                                            onClick: _cache[17] || (_cache[17] = ($event: any) => (onSubmitApply()))
                                          }, [
                                            (tenantLogoGuid.value)
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_217))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(startButtonText()), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})